import { pagination_preference } from 'constants/paginationPreferences';

import { updateUserProfileDetails } from 'services/profileServices';
import { checkKeyIsPresentInObject } from 'utils/utils';

export function handlePageNumberInPagination(
  userContext,
  module,
  subModule,
  listName,
  pageNumber,
  filterName,
  filterData,
  excludeFromLoading
) {
  let newPrefernces = JSON.parse(JSON.stringify(pagination_preference));
  const isAlreadyPresent = subModule
    ? userContext?.firmDetails?.pagination_preference?.hasOwnProperty(module) &&
      userContext?.firmDetails?.pagination_preference?.settings?.hasOwnProperty(subModule) &&
      userContext?.firmDetails?.pagination_preference?.settings?.custom_descriptors?.hasOwnProperty(listName)
    : userContext?.firmDetails?.pagination_preference?.hasOwnProperty(module) &&
      userContext?.firmDetails?.pagination_preference?.settings?.custom_descriptors?.hasOwnProperty(listName);

  if ('pagination_preference' in userContext?.firmDetails && isAlreadyPresent) {
    if (subModule && !filterName) {
      userContext.firmDetails.pagination_preference[module][subModule][listName] = pageNumber;
    } else if (subModule && filterName) {
      userContext.firmDetails.pagination_preference[module][subModule][listName][filterName] = filterData;
    } else {
      userContext.firmDetails.pagination_preference[module][listName] = pageNumber;
    }
  } else {
    if ('pagination_preference' in userContext?.firmDetails && !isAlreadyPresent) {
      newPrefernces = userContext.firmDetails.pagination_preference;
    }
    if (subModule && !filterName) {
      (newPrefernces[module][subModule] ??= {})[listName] = pageNumber;
    } else if (subModule && filterName) {
      (newPrefernces[module] ??= {})[subModule] ??= {};
      (newPrefernces[module][subModule][listName] ??= {})[filterName] = filterData;
    } else {
      (newPrefernces[module] ??= {})[listName] ??= {};
      newPrefernces[module][listName] = pageNumber;
    }
  }
  let sendData = {
    bypass_logs: true,
  };
  sendData.pk = userContext?.firmDetails.pk;
  sendData.sk = userContext?.firmDetails.sk;
  sendData.pagination_preference =
    'pagination_preference' in userContext?.firmDetails && isAlreadyPresent
      ? userContext?.firmDetails?.pagination_preference
      : newPrefernces;
  if (sendData) {
    updateUserProfileDetails(sendData, excludeFromLoading)
      .then((data) => {
        if (data) {
          userContext
            .loadUserDetails('', excludeFromLoading)
            .then((userDetails) => {
              sendData = {};
            })
            .catch((err) => console.log({ err }));
        }
      })
      .catch((err) => console.log({ err }));
  }
}

// Debounce utility to prevent excessive API calls
let updateProfileTimeout = null;

export const updateProfile = (userContext, sendData, excludeFromLoading) => {
  // Clear any existing timeout to debounce rapid calls
  if (updateProfileTimeout) {
    clearTimeout(updateProfileTimeout);
  }

  // Debounce the update to prevent rapid successive calls
  updateProfileTimeout = setTimeout(() => {
    updateUserProfileDetails(sendData, excludeFromLoading)
      .then((data) => {
        if (data) {
          userContext
            .loadUserDetails('', excludeFromLoading)
            .then((userDetails) => {})
            .catch((err) => console.log({ err }));
        }
      })
      .catch((err) => console.log({ err }));
  }, 300); // 300ms debounce delay
};

export function handleFilterUpdateInUserContext(userContext, module, subModule, listName, filterName, filterData, excludeFromLoading) {
  let newPrefernces = userContext?.firmDetails?.user_preferences ? userContext?.firmDetails?.user_preferences : userContext?.firmDetails;

  const isAlreadyPresent = userContext?.firmDetails?.user_preferences
    ? (listName === null
        ? checkKeyIsPresentInObject(userContext?.firmDetails?.user_preferences, subModule)
        : checkKeyIsPresentInObject(userContext?.firmDetails?.user_preferences, listName)) &&
      checkKeyIsPresentInObject(userContext?.firmDetails?.user_preferences, filterName)
    : false;

  if ('user_preferences' in userContext?.firmDetails && isAlreadyPresent) {
    if (listName) {
      userContext.firmDetails.user_preferences[module][subModule][listName][filterName] = filterData;
    } else {
      userContext.firmDetails.user_preferences[module][subModule][filterName] = filterData;
    }
  } else if ('user_preferences' in userContext?.firmDetails && !isAlreadyPresent) {
    if (subModule && filterName && !listName) {
      (newPrefernces[module] ??= {})[subModule] ??= {};
      newPrefernces[module][subModule][filterName] = filterData;
    } else if (subModule && filterName && listName) {
      (newPrefernces[module] ??= {})[subModule] ??= {};
      (newPrefernces[module][subModule][listName] ??= {})[filterName] = filterData;
    }
  } else {
    if (!userContext?.firmDetails.hasOwnProperty('user_preferences') && !listName) {
      newPrefernces['user_preferences'] = {};
      (newPrefernces['user_preferences'][module] ??= {})[subModule] ??= {};
      newPrefernces['user_preferences'][module][subModule][filterName] ??= {};
      newPrefernces['user_preferences'][module][subModule][filterName] = filterData;
    } else if (!userContext?.firmDetails.hasOwnProperty('user_preferences') && listName) {
      newPrefernces['user_preferences'] = {};
      (newPrefernces['user_preferences'][module] ??= {})[subModule] ??= {};
      (newPrefernces['user_preferences'][module][subModule][listName] ??= {})[filterName] = {};
      newPrefernces['user_preferences'][module][subModule][listName][filterName] = filterData;
    }
  }
  newPrefernces = newPrefernces?.user_preferences ? newPrefernces?.user_preferences : newPrefernces;
  let sendData = {
    bypass_logs: true,
  };
  sendData.update_preference = true;
  sendData.pk = userContext?.firmDetails.pk;
  sendData.sk = userContext?.firmDetails.sk;
  sendData.user_preferences =
    'user_preferences' in userContext?.firmDetails && isAlreadyPresent ? userContext?.firmDetails?.user_preferences : newPrefernces;
  if (sendData) {
    updateProfile(userContext, sendData, excludeFromLoading);
  }
}

export function resetFilterHandler(userContext, module, subModule, filterData, excludeFromLoading) {
  let sendData = {};
  if (userContext?.firmDetails?.user_preferences?.[module]?.[subModule]) {
    sendData = {
      pk: userContext?.firmDetails?.pk,
      sk: userContext?.firmDetails?.sk,
      user_preferences: {
        ...(userContext?.firmDetails?.user_preferences || {}),
        [module]: {
          ...(userContext?.firmDetails?.user_preferences?.[module] || {}),
          [subModule]: filterData || {},
        },
      },
      bypass_logs: true,
      update_preference: true,
    };
  }
  if (sendData) {
    updateProfile(userContext, sendData, excludeFromLoading);
  }
}

export function handleFilterResetInTask(userContext, module, subModule, listName, filterDataSet, excludeFromLoading) {
  let newPrefernces = userContext?.firmDetails?.user_preferences ? userContext?.firmDetails?.user_preferences : userContext?.firmDetails;
  let isAlreadyPresent = false;
  for (var filterName in filterDataSet) {
    isAlreadyPresent = userContext?.firmDetails?.user_preferences
      ? (listName === null
          ? checkKeyIsPresentInObject(userContext?.firmDetails?.user_preferences, subModule)
          : checkKeyIsPresentInObject(userContext?.firmDetails?.user_preferences, listName)) &&
        checkKeyIsPresentInObject(userContext?.firmDetails?.user_preferences, filterName)
      : false;

    if ('user_preferences' in userContext?.firmDetails && isAlreadyPresent) {
      if (listName) {
        userContext.firmDetails.user_preferences[module][subModule][listName][filterName] = filterDataSet[filterName];
      } else {
        userContext.firmDetails.user_preferences[module][subModule][filterName] = filterDataSet[filterName];
      }
    } else if ('user_preferences' in userContext?.firmDetails && !isAlreadyPresent) {
      if (subModule && filterName && !listName) {
        (newPrefernces[module] ??= {})[subModule] ??= {};
        newPrefernces[module][subModule][filterName] = filterDataSet[filterName];
      } else if (subModule && filterName && listName) {
        (newPrefernces[module] ??= {})[subModule] ??= {};
        (newPrefernces[module][subModule][listName] ??= {})[filterName] = filterDataSet[filterName];
      }
    } else {
      if (!userContext?.firmDetails.hasOwnProperty('user_preferences') && !listName) {
        newPrefernces['user_preferences'] = {};
        (newPrefernces['user_preferences'][module] ??= {})[subModule] ??= {};
        newPrefernces['user_preferences'][module][subModule][filterName] ??= {};
        newPrefernces['user_preferences'][module][subModule][filterName] = filterDataSet[filterName];
      } else if (!userContext?.firmDetails.hasOwnProperty('user_preferences') && listName) {
        newPrefernces['user_preferences'] = {};
        (newPrefernces['user_preferences'][module] ??= {})[subModule] ??= {};
        (newPrefernces['user_preferences'][module][subModule][listName] ??= {})[filterName] = {};
        newPrefernces['user_preferences'][module][subModule][listName][filterName] = filterDataSet[filterName];
      }
    }
  }
  newPrefernces = newPrefernces?.user_preferences ? newPrefernces?.user_preferences : newPrefernces;
  let sendData = {
    bypass_logs: true,
  };
  sendData.pk = userContext?.firmDetails.pk;
  sendData.sk = userContext?.firmDetails.sk;
  sendData.user_preferences =
    'user_preferences' in userContext?.firmDetails && isAlreadyPresent ? userContext?.firmDetails?.user_preferences : newPrefernces;
  if (sendData) {
    updateProfile(userContext, sendData, excludeFromLoading);
  }
}

export const updateTableColumnWidths = (userContext, storageKey = 'default_column_width', widths = {}) => {
  let newPrefernces = userContext?.firmDetails?.user_preferences?.table_column || {};
  newPrefernces[storageKey] = widths;
  let sendData = {
    bypass_logs: true,
  };
  sendData.pk = userContext?.firmDetails.pk;
  sendData.sk = userContext?.firmDetails.sk;
  sendData.user_preferences = { ...(userContext?.firmDetails?.user_preferences || {}), table_column: newPrefernces };
  updateProfile(userContext, sendData, true);
};

export function handleFilterResetUserContext(userContext, module, subModule, listName, filterDataSet, excludeFromLoading) {
  if (!userContext.firmDetails.user_preferences) {
    userContext.firmDetails.user_preferences = {};
  }

  const preferences = userContext.firmDetails.user_preferences;

  preferences[module] ??= {};
  preferences[module][subModule] ??= {};

  if (listName) {
    const currentListFilters = preferences[module][subModule][listName] ?? {};

    const retainVal = subModule === 'report' ? currentListFilters.retain_filters : undefined;

    preferences[module][subModule][listName] = {
      ...filterDataSet,
      ...(retainVal !== undefined ? { retain_filters: retainVal } : {}),
    };
  } else {
    preferences[module][subModule] = { ...filterDataSet };
  }

  const sendData = {
    pk: userContext.firmDetails.pk,
    sk: userContext.firmDetails.sk,
    user_preferences: preferences,
    bypass_logs: true,
    update_preference: true,
  };

  if (sendData) {
    updateProfile(userContext, sendData, excludeFromLoading);
  }
}
